const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpsilon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "338px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.555
    },
    fill: "#3f3f3f",
    d: "M 310.5,93.5 C 310.5,94.1667 310.5,94.8333 310.5,95.5C 307.813,95.3359 305.146,95.5026 302.5,96C 300.831,97.669 298.831,98.5023 296.5,98.5C 299.98,93.9716 304.646,92.305 310.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#8a8a8a",
    d: "M 310.5,93.5 C 312.632,93.5544 313.965,94.5544 314.5,96.5C 313.167,96.1667 311.833,95.8333 310.5,95.5C 310.5,94.8333 310.5,94.1667 310.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#070707",
    d: "M 310.5,95.5 C 311.833,95.8333 313.167,96.1667 314.5,96.5C 314.685,98.1958 315.519,99.5291 317,100.5C 317.667,103.5 317.667,106.5 317,109.5C 315.55,111.757 314.383,114.09 313.5,116.5C 312.833,116.5 312.167,116.5 311.5,116.5C 310.791,115.596 309.791,115.263 308.5,115.5C 306.833,115.5 305.167,115.5 303.5,115.5C 302.508,115.328 301.842,115.662 301.5,116.5C 300.167,116.5 299.5,115.833 299.5,114.5C 298.4,113.395 297.733,112.062 297.5,110.5C 295.905,106.769 296.238,103.269 298.5,100C 297.906,99.5357 297.239,99.369 296.5,99.5C 296.5,99.1667 296.5,98.8333 296.5,98.5C 298.831,98.5023 300.831,97.669 302.5,96C 305.146,95.5026 307.813,95.3359 310.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#6f6f6f",
    d: "M 331.5,94.5 C 331.5,132.833 331.5,171.167 331.5,209.5C 337.425,209.808 343.259,209.475 349,208.5C 349.5,170.501 349.667,132.501 349.5,94.5C 350.833,133.5 350.833,172.5 349.5,211.5C 343.5,210.167 337.5,210.167 331.5,211.5C 330.83,173.098 330.164,134.598 329.5,96C 330.044,95.2828 330.711,94.7828 331.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#060606",
    d: "M 331.5,94.5 C 337.5,94.5 343.5,94.5 349.5,94.5C 349.667,132.501 349.5,170.501 349,208.5C 343.259,209.475 337.425,209.808 331.5,209.5C 331.5,171.167 331.5,132.833 331.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#707070",
    d: "M 37.5,102.5 C 36.8902,103.391 36.5569,104.391 36.5,105.5C 35.209,105.737 34.209,105.404 33.5,104.5C 34.8333,103.833 36.1667,103.167 37.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.165
    },
    fill: "#171717",
    d: "M 37.5,102.5 C 60.5,102.5 83.5,102.5 106.5,102.5C 106.5,103.5 106.5,104.5 106.5,105.5C 105.272,106.306 104.272,107.306 103.5,108.5C 103.5,106.833 103.5,105.167 103.5,103.5C 81.8308,103.333 60.1641,103.5 38.5,104C 37.9558,104.717 37.2891,105.217 36.5,105.5C 36.5569,104.391 36.8902,103.391 37.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.235
    },
    fill: "#848484",
    d: "M 314.5,96.5 C 317.981,98.5338 319.314,101.7 318.5,106C 318.943,110.618 317.276,114.118 313.5,116.5C 314.383,114.09 315.55,111.757 317,109.5C 317.667,106.5 317.667,103.5 317,100.5C 315.519,99.5291 314.685,98.1958 314.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#030303",
    d: "M 103.5,108.5 C 102.385,112.063 100.718,115.397 98.5,118.5C 95.821,118.525 94.4877,119.858 94.5,122.5C 93.1667,122.5 91.8333,122.5 90.5,122.5C 90.5,121.833 90.1667,121.5 89.5,121.5C 73.1633,121.333 56.8299,121.5 40.5,122C 39.244,122.417 38.5774,123.25 38.5,124.5C 38.5,125.167 38.1667,125.5 37.5,125.5C 36.5326,126.806 35.1993,127.473 33.5,127.5C 33.5,128.5 33.5,129.5 33.5,130.5C 32.5,130.5 31.5,130.5 30.5,130.5C 30.5,131.833 30.5,133.167 30.5,134.5C 29.8333,134.5 29.5,134.833 29.5,135.5C 28.0695,135.421 26.7362,135.754 25.5,136.5C 24.2267,137.257 24.2267,137.923 25.5,138.5C 25.5,138.833 25.5,139.167 25.5,139.5C 24.1667,139.5 22.8333,139.5 21.5,139.5C 21.5,132.5 21.5,125.5 21.5,118.5C 23.9489,114.526 27.1156,110.86 31,107.5C 31.4828,106.552 31.6495,105.552 31.5,104.5C 32.1667,104.5 32.8333,104.5 33.5,104.5C 34.209,105.404 35.209,105.737 36.5,105.5C 37.2891,105.217 37.9558,104.717 38.5,104C 60.1641,103.5 81.8308,103.333 103.5,103.5C 103.5,105.167 103.5,106.833 103.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.438
    },
    fill: "#383838",
    d: "M 296.5,99.5 C 297.239,99.369 297.906,99.5357 298.5,100C 296.238,103.269 295.905,106.769 297.5,110.5C 295.158,107.229 294.824,103.562 296.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.404
    },
    fill: "#525252",
    d: "M 31.5,104.5 C 31.6495,105.552 31.4828,106.552 31,107.5C 27.1156,110.86 23.9489,114.526 21.5,118.5C 22.86,112.455 26.1933,107.788 31.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.235
    },
    fill: "#838383",
    d: "M 296.5,98.5 C 296.5,98.8333 296.5,99.1667 296.5,99.5C 294.824,103.562 295.158,107.229 297.5,110.5C 297.733,112.062 298.4,113.395 299.5,114.5C 295.918,113.404 293.918,110.904 293.5,107C 294.274,104.595 294.774,102.095 295,99.5C 295.383,98.944 295.883,98.6107 296.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#7e7e7e",
    d: "M 106.5,105.5 C 105.999,111.24 103.332,115.574 98.5,118.5C 100.718,115.397 102.385,112.063 103.5,108.5C 104.272,107.306 105.272,106.306 106.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#737373",
    d: "M 301.5,116.5 C 301.842,115.662 302.508,115.328 303.5,115.5C 305.417,117.851 307.084,117.851 308.5,115.5C 309.791,115.263 310.791,115.596 311.5,116.5C 308.167,119.167 304.833,119.167 301.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.549
    },
    fill: "#363636",
    d: "M 303.5,115.5 C 305.167,115.5 306.833,115.5 308.5,115.5C 307.084,117.851 305.417,117.851 303.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#7d7d7d",
    d: "M 98.5,118.5 C 97.467,120.085 96.1336,121.419 94.5,122.5C 94.4877,119.858 95.821,118.525 98.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.506
    },
    fill: "#383838",
    d: "M 89.5,121.5 C 74.0054,122.331 58.3387,122.831 42.5,123C 41.0993,123.41 39.766,123.91 38.5,124.5C 38.5774,123.25 39.244,122.417 40.5,122C 56.8299,121.5 73.1633,121.333 89.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#525252",
    d: "M 403.5,122.5 C 408.167,122.5 412.833,122.5 417.5,122.5C 418.11,123.391 418.443,124.391 418.5,125.5C 413.527,124.045 408.527,123.045 403.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#454545",
    d: "M 513.5,122.5 C 506.654,123.858 499.654,125.525 492.5,127.5C 493.11,126.609 493.443,125.609 493.5,124.5C 499.94,122.677 506.607,122.01 513.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6c6c6c",
    d: "M 89.5,121.5 C 90.1667,121.5 90.5,121.833 90.5,122.5C 90.3893,123.117 90.056,123.617 89.5,124C 73.1667,124.333 56.8333,124.667 40.5,125C 39.6266,126.045 38.6266,126.878 37.5,127.5C 37.5,126.833 37.5,126.167 37.5,125.5C 38.1667,125.5 38.5,125.167 38.5,124.5C 39.766,123.91 41.0993,123.41 42.5,123C 58.3387,122.831 74.0054,122.331 89.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#606060",
    d: "M 152.5,122.5 C 152.586,123.496 152.252,124.329 151.5,125C 149.934,125.765 148.601,125.598 147.5,124.5C 149.322,124.169 150.989,123.502 152.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#040404",
    d: "M 152.5,122.5 C 154.167,122.5 155.833,122.5 157.5,122.5C 162.081,124.327 167.081,125.327 172.5,125.5C 173.791,125.737 174.791,125.404 175.5,124.5C 176.167,124.5 176.833,124.5 177.5,124.5C 177.958,127.309 179.291,127.976 181.5,126.5C 181.833,126.5 182.167,126.5 182.5,126.5C 188.718,132.215 194.885,138.215 201,144.5C 202.211,146.921 203.377,149.255 204.5,151.5C 204.318,153.591 204.652,155.591 205.5,157.5C 206.325,158.386 207.325,158.719 208.5,158.5C 208.5,165.167 208.5,171.833 208.5,178.5C 207.5,178.5 206.5,178.5 205.5,178.5C 205.291,182.909 203.958,186.909 201.5,190.5C 200.168,192.138 198.834,193.804 197.5,195.5C 194.051,198.934 191.051,202.601 188.5,206.5C 188.167,206.5 187.833,206.5 187.5,206.5C 187.44,205.957 187.107,205.624 186.5,205.5C 184.054,206.524 182.388,208.191 181.5,210.5C 180.833,210.5 180.167,210.5 179.5,210.5C 178.791,209.596 177.791,209.263 176.5,209.5C 176.5,210.5 176.5,211.5 176.5,212.5C 175.5,212.5 174.5,212.5 173.5,212.5C 172.081,211.549 170.415,211.216 168.5,211.5C 164.167,212.833 159.833,212.833 155.5,211.5C 153.901,211.232 152.568,211.566 151.5,212.5C 150.833,212.5 150.167,212.5 149.5,212.5C 149.042,209.691 147.709,209.024 145.5,210.5C 145.167,210.5 144.833,210.5 144.5,210.5C 144.226,208.019 142.893,206.353 140.5,205.5C 139.005,202.664 136.839,201.664 134,202.5C 133.981,211.97 133.148,221.303 131.5,230.5C 130.581,233.089 128.914,235.089 126.5,236.5C 123.448,238.178 120.115,238.845 116.5,238.5C 116.5,214.167 116.5,189.833 116.5,165.5C 116.833,163.5 117.167,161.5 117.5,159.5C 117.955,155.043 118.955,150.71 120.5,146.5C 121.5,146.5 122.5,146.5 123.5,146.5C 123.343,145.127 123.51,143.793 124,142.5C 127.371,139.297 130.538,135.964 133.5,132.5C 133.5,131.167 134.167,130.5 135.5,130.5C 138.034,130.741 139.7,129.741 140.5,127.5C 141.209,126.596 142.209,126.263 143.5,126.5C 145.332,127.718 146.332,127.051 146.5,124.5C 146.833,124.5 147.167,124.5 147.5,124.5C 148.601,125.598 149.934,125.765 151.5,125C 152.252,124.329 152.586,123.496 152.5,122.5 Z M 156.5,142.5 C 158.167,142.5 159.833,142.5 161.5,142.5C 161.833,142.5 162.167,142.5 162.5,142.5C 163.833,142.5 165.167,142.5 166.5,142.5C 168.284,142.893 169.95,143.559 171.5,144.5C 172.167,144.5 172.833,144.5 173.5,144.5C 177.213,147.884 180.879,151.217 184.5,154.5C 184.4,157.108 185.067,159.442 186.5,161.5C 186.5,162.167 186.5,162.833 186.5,163.5C 186.5,164.5 186.5,165.5 186.5,166.5C 186.322,169.879 186.322,173.045 186.5,176C 184.771,177.789 184.104,179.956 184.5,182.5C 182.215,184.118 180.215,186.118 178.5,188.5C 178.167,188.5 177.833,188.5 177.5,188.5C 174.167,190.5 170.833,192.5 167.5,194.5C 163.5,194.5 159.5,194.5 155.5,194.5C 154.778,193.449 153.778,192.782 152.5,192.5C 152.167,192.5 151.833,192.5 151.5,192.5C 150.5,191.833 149.5,191.167 148.5,190.5C 148.167,190.5 147.833,190.5 147.5,190.5C 146.833,189.833 146.167,189.167 145.5,188.5C 145.167,188.5 144.833,188.5 144.5,188.5C 140.967,184.648 138.3,180.314 136.5,175.5C 136.5,175.167 136.5,174.833 136.5,174.5C 136.5,173.833 136.5,173.167 136.5,172.5C 136.5,169.833 136.5,167.167 136.5,164.5C 138.374,152.879 145.041,145.546 156.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.737
    },
    fill: "#424242",
    d: "M 157.5,122.5 C 162.167,122.5 166.833,122.5 171.5,122.5C 172.11,123.391 172.443,124.391 172.5,125.5C 167.081,125.327 162.081,124.327 157.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.737
    },
    fill: "#414141",
    d: "M 240.5,122.5 C 244.167,122.5 247.833,122.5 251.5,122.5C 247.928,124.29 243.928,125.29 239.5,125.5C 240.11,124.609 240.443,123.609 240.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#030303",
    d: "M 251.5,122.5 C 252.833,122.5 254.167,122.5 255.5,122.5C 256.234,123.708 256.567,125.041 256.5,126.5C 260.146,126.577 263.479,127.577 266.5,129.5C 267.107,129.376 267.44,129.043 267.5,128.5C 267.833,128.5 268.167,128.5 268.5,128.5C 270.051,131.563 272.218,134.229 275,136.5C 275.655,138.628 276.489,140.628 277.5,142.5C 278.15,144.435 278.483,146.435 278.5,148.5C 272.833,148.5 267.167,148.5 261.5,148.5C 260.391,148.443 259.391,148.11 258.5,147.5C 258.5,147.167 258.5,146.833 258.5,146.5C 259.686,145.295 259.686,143.961 258.5,142.5C 257.263,140.903 255.596,139.737 253.5,139C 250.304,138.195 247.304,138.362 244.5,139.5C 243.094,139.973 242.427,140.973 242.5,142.5C 242.167,142.5 241.833,142.5 241.5,142.5C 240.207,141.355 239.041,141.689 238,143.5C 237.333,146.167 237.333,148.833 238,151.5C 238.671,152.252 239.504,152.586 240.5,152.5C 240.5,153.833 240.5,155.167 240.5,156.5C 246.522,158.212 252.522,159.879 258.5,161.5C 259.791,161.737 260.791,161.404 261.5,160.5C 262.5,160.5 263.5,160.5 264.5,160.5C 264.975,162.722 265.975,163.389 267.5,162.5C 267.833,162.5 268.167,162.5 268.5,162.5C 268.5,163.5 268.5,164.5 268.5,165.5C 269.791,165.737 270.791,165.404 271.5,164.5C 271.833,164.5 272.167,164.5 272.5,164.5C 274.459,168.126 277.126,171.126 280.5,173.5C 280.993,175.806 281.326,178.139 281.5,180.5C 281.144,186.638 280.144,192.638 278.5,198.5C 276.861,200.806 274.861,202.806 272.5,204.5C 269.376,206.98 266.043,208.98 262.5,210.5C 256.185,211.11 249.851,211.443 243.5,211.5C 241.901,211.232 240.568,211.566 239.5,212.5C 238.5,212.5 237.5,212.5 236.5,212.5C 236.332,209.949 235.332,209.282 233.5,210.5C 233.167,210.5 232.833,210.5 232.5,210.5C 232.573,208.973 231.906,207.973 230.5,207.5C 230.5,206.5 230.5,205.5 230.5,204.5C 227.892,204.6 225.558,203.933 223.5,202.5C 221.833,200 220.5,197.333 219.5,194.5C 219.125,192.302 218.458,190.302 217.5,188.5C 217.5,187.833 217.5,187.167 217.5,186.5C 223.167,186.5 228.833,186.5 234.5,186.5C 234.263,187.791 234.596,188.791 235.5,189.5C 236.931,189.881 237.764,190.881 238,192.5C 238.383,191.944 238.883,191.611 239.5,191.5C 239.5,192.167 239.833,192.5 240.5,192.5C 240.626,195.595 242.293,197.428 245.5,198C 248.696,198.805 251.696,198.638 254.5,197.5C 254.557,196.391 254.89,195.391 255.5,194.5C 256.167,194.5 256.833,194.5 257.5,194.5C 257.897,195.525 258.563,195.692 259.5,195C 260.733,193.333 262.067,191.833 263.5,190.5C 266.046,183.242 263.712,178.242 256.5,175.5C 255.209,175.263 254.209,175.596 253.5,176.5C 252.833,176.5 252.167,176.5 251.5,176.5C 250.113,173.674 248.113,173.007 245.5,174.5C 244.5,174.5 243.5,174.5 242.5,174.5C 242.5,173.5 242.5,172.5 242.5,171.5C 241.209,171.263 240.209,171.596 239.5,172.5C 238.833,172.5 238.167,172.5 237.5,172.5C 237.586,171.504 237.252,170.671 236.5,170C 232.507,168.665 229.174,166.332 226.5,163C 225.552,162.517 224.552,162.351 223.5,162.5C 223.167,162.5 222.833,162.5 222.5,162.5C 222.5,161.167 222.5,159.833 222.5,158.5C 219.418,150.149 220.085,142.149 224.5,134.5C 226.167,132.5 227.833,130.5 229.5,128.5C 229.5,127.167 230.167,126.5 231.5,126.5C 234.096,127.209 236.763,126.875 239.5,125.5C 243.928,125.29 247.928,124.29 251.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#8b8b8b",
    d: "M 316.5,123.5 C 317.833,152.833 317.833,182.167 316.5,211.5C 316.48,182.375 316.48,153.041 316.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#606060",
    d: "M 398.5,122.5 C 398.586,123.496 398.252,124.329 397.5,125C 395.934,125.765 394.601,125.598 393.5,124.5C 395.322,124.169 396.989,123.502 398.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#040404",
    d: "M 398.5,122.5 C 400.167,122.5 401.833,122.5 403.5,122.5C 408.527,123.045 413.527,124.045 418.5,125.5C 419.791,125.737 420.791,125.404 421.5,124.5C 422.167,124.5 422.833,124.5 423.5,124.5C 424.226,127.013 425.559,127.679 427.5,126.5C 428.167,126.5 428.833,126.5 429.5,126.5C 429.281,127.675 429.614,128.675 430.5,129.5C 431.107,129.376 431.44,129.043 431.5,128.5C 432.833,128.5 433.5,129.167 433.5,130.5C 434.167,131.833 435.167,132.833 436.5,133.5C 438.833,136.5 441.5,139.167 444.5,141.5C 445.676,145.136 447.842,148.136 451,150.5C 451.495,152.473 451.662,154.473 451.5,156.5C 452.833,164.5 452.833,172.5 451.5,180.5C 451.675,182.621 451.341,184.621 450.5,186.5C 446.959,192.715 442.293,198.048 436.5,202.5C 433.646,204.509 430.646,206.343 427.5,208C 426.748,208.671 426.414,209.504 426.5,210.5C 426.167,210.5 425.833,210.5 425.5,210.5C 423.291,209.024 421.958,209.691 421.5,212.5C 420.833,212.5 420.167,212.5 419.5,212.5C 418.081,211.549 416.415,211.216 414.5,211.5C 407.964,212.211 401.631,212.211 395.5,211.5C 395.5,211.833 395.5,212.167 395.5,212.5C 394.5,212.5 393.5,212.5 392.5,212.5C 392.5,211.5 392.5,210.5 392.5,209.5C 391.209,209.263 390.209,209.596 389.5,210.5C 389.167,210.5 388.833,210.5 388.5,210.5C 388.027,209.094 387.027,208.427 385.5,208.5C 385.167,208.5 384.833,208.5 384.5,208.5C 384.264,206.027 382.931,204.36 380.5,203.5C 379.893,203.624 379.56,203.957 379.5,204.5C 379.167,204.5 378.833,204.5 378.5,204.5C 378.719,203.325 378.386,202.325 377.5,201.5C 375.867,199.497 373.867,198.164 371.5,197.5C 370.833,197.5 370.5,197.167 370.5,196.5C 370.147,192.174 368.48,188.507 365.5,185.5C 363.956,182.752 363.29,179.752 363.5,176.5C 363.108,174.821 362.608,173.154 362,171.5C 361.617,172.056 361.117,172.389 360.5,172.5C 360.5,169.5 360.5,166.5 360.5,163.5C 361.825,164.953 362.658,164.619 363,162.5C 363.943,159.155 364.777,155.822 365.5,152.5C 366.03,149.318 367.03,146.318 368.5,143.5C 371.822,139.848 375.488,136.515 379.5,133.5C 380.386,132.675 380.719,131.675 380.5,130.5C 380.833,130.5 381.167,130.5 381.5,130.5C 381.56,131.043 381.893,131.376 382.5,131.5C 384.931,130.64 386.264,128.973 386.5,126.5C 387.5,126.5 388.5,126.5 389.5,126.5C 391.332,127.718 392.332,127.051 392.5,124.5C 392.833,124.5 393.167,124.5 393.5,124.5C 394.601,125.598 395.934,125.765 397.5,125C 398.252,124.329 398.586,123.496 398.5,122.5 Z M 401.5,142.5 C 405.167,142.5 408.833,142.5 412.5,142.5C 413.5,142.5 414.5,142.5 415.5,142.5C 421.336,145.158 426.169,149.158 430,154.5C 430.642,158.987 432.142,163.487 434.5,168C 433.962,169.899 433.295,172.066 432.5,174.5C 432.5,174.833 432.5,175.167 432.5,175.5C 431.557,178.66 430.223,181.66 428.5,184.5C 425.521,187.65 422.188,190.317 418.5,192.5C 417.833,192.5 417.167,192.5 416.5,192.5C 415.5,193.167 414.5,193.833 413.5,194.5C 409.833,194.5 406.167,194.5 402.5,194.5C 399.22,192.86 395.886,191.193 392.5,189.5C 389.403,186.745 386.737,183.745 384.5,180.5C 384.5,179.833 384.5,179.167 384.5,178.5C 383.067,176.442 382.4,174.108 382.5,171.5C 382.5,168.833 382.5,166.167 382.5,163.5C 383.754,158.808 385.754,154.474 388.5,150.5C 389.5,150.167 390.167,149.5 390.5,148.5C 392.461,147.54 394.127,146.207 395.5,144.5C 396.167,144.5 396.833,144.5 397.5,144.5C 398.833,143.833 400.167,143.167 401.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#767676",
    d: "M 171.5,122.5 C 172.833,123.167 174.167,123.833 175.5,124.5C 174.791,125.404 173.791,125.737 172.5,125.5C 172.443,124.391 172.11,123.391 171.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.235
    },
    fill: "#919191",
    d: "M 315.5,122.5 C 315.5,122.833 315.5,123.167 315.5,123.5C 309.5,123.5 303.5,123.5 297.5,123.5C 297.5,147.833 297.5,172.167 297.5,196.5C 297.5,197.167 297.5,197.833 297.5,198.5C 296.502,173.339 296.169,148.005 296.5,122.5C 302.833,122.5 309.167,122.5 315.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#020202",
    d: "M 315.5,124.5 C 315.667,152.502 315.5,180.502 315,208.5C 313.052,209.109 311.218,209.776 309.5,210.5C 309.167,210.5 308.833,210.5 308.5,210.5C 306.592,206.92 303.926,203.92 300.5,201.5C 299.678,199.861 299.011,198.195 298.5,196.5C 298.5,172.5 298.5,148.5 298.5,124.5C 304.167,124.5 309.833,124.5 315.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#616161",
    d: "M 315.5,122.5 C 316.167,122.5 316.5,122.833 316.5,123.5C 316.48,153.041 316.48,182.375 316.5,211.5C 316.083,212.124 315.416,212.457 314.5,212.5C 312.823,211.813 311.156,211.146 309.5,210.5C 311.218,209.776 313.052,209.109 315,208.5C 315.5,180.502 315.667,152.502 315.5,124.5C 315.5,124.167 315.5,123.833 315.5,123.5C 315.5,123.167 315.5,122.833 315.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#767676",
    d: "M 417.5,122.5 C 418.833,123.167 420.167,123.833 421.5,124.5C 420.791,125.404 419.791,125.737 418.5,125.5C 418.443,124.391 418.11,123.391 417.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#030303",
    d: "M 513.5,122.5 C 514.833,122.5 516.167,122.5 517.5,122.5C 518.226,125.013 519.559,125.679 521.5,124.5C 521.833,124.5 522.167,124.5 522.5,124.5C 522.975,126.722 523.975,127.389 525.5,126.5C 526.167,126.5 526.833,126.5 527.5,126.5C 527.281,127.675 527.614,128.675 528.5,129.5C 529.107,129.376 529.44,129.043 529.5,128.5C 529.833,128.5 530.167,128.5 530.5,128.5C 531.124,130.754 532.457,132.421 534.5,133.5C 537.272,137.28 540.605,140.28 544.5,142.5C 544.517,144.565 544.85,146.565 545.5,148.5C 546.01,151.943 546.844,155.276 548,158.5C 548.5,175.497 548.667,192.497 548.5,209.5C 543.167,209.5 537.833,209.5 532.5,209.5C 532.83,192.991 532.496,176.658 531.5,160.5C 531.073,157.99 530.407,155.657 529.5,153.5C 527.345,149.664 524.345,146.331 520.5,143.5C 519.893,143.624 519.56,143.957 519.5,144.5C 519.167,144.5 518.833,144.5 518.5,144.5C 518.573,142.973 517.906,141.973 516.5,141.5C 510.5,138.833 504.5,138.833 498.5,141.5C 497.292,142.234 495.959,142.567 494.5,142.5C 494.5,143.833 494.5,145.167 494.5,146.5C 493.833,146.5 493.5,146.833 493.5,147.5C 487.907,149.307 485.24,153.307 485.5,159.5C 485.511,161.045 485.844,162.378 486.5,163.5C 486.5,179.167 486.5,194.833 486.5,210.5C 480.788,210.703 474.455,210.703 467.5,210.5C 467.5,193.5 467.5,176.5 467.5,159.5C 467.795,157.265 467.461,155.265 466.5,153.5C 466.263,152.209 466.596,151.209 467.5,150.5C 469.074,150.063 470.241,149.063 471,147.5C 472.14,144.898 472.973,142.231 473.5,139.5C 476.404,138.386 478.404,136.386 479.5,133.5C 480.545,132.122 481.878,131.122 483.5,130.5C 483.56,131.043 483.893,131.376 484.5,131.5C 486.931,130.64 488.264,128.973 488.5,126.5C 488.833,126.5 489.167,126.5 489.5,126.5C 490.209,127.404 491.209,127.737 492.5,127.5C 499.654,125.525 506.654,123.858 513.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#767676",
    d: "M 517.5,122.5 C 518.833,123.167 520.167,123.833 521.5,124.5C 519.559,125.679 518.226,125.013 517.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.302
    },
    fill: "#575757",
    d: "M 240.5,122.5 C 240.443,123.609 240.11,124.609 239.5,125.5C 236.763,126.875 234.096,127.209 231.5,126.5C 234.5,125.167 237.5,123.833 240.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.489
    },
    fill: "#434343",
    d: "M 255.5,122.5 C 260.02,123.615 264.02,125.615 267.5,128.5C 267.44,129.043 267.107,129.376 266.5,129.5C 263.479,127.577 260.146,126.577 256.5,126.5C 256.567,125.041 256.234,123.708 255.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#272727",
    d: "M 315.5,123.5 C 315.5,123.833 315.5,124.167 315.5,124.5C 309.833,124.5 304.167,124.5 298.5,124.5C 298.5,148.5 298.5,172.5 298.5,196.5C 298.167,196.5 297.833,196.5 297.5,196.5C 297.5,172.167 297.5,147.833 297.5,123.5C 303.5,123.5 309.5,123.5 315.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.438
    },
    fill: "#4f4f4f",
    d: "M 559.5,122.5 C 559.169,124.322 558.502,125.989 557.5,127.5C 556.89,128.391 556.557,129.391 556.5,130.5C 556.5,131.5 556.5,132.5 556.5,133.5C 555.71,132.391 555.21,131.058 555,129.5C 554.617,130.056 554.117,130.389 553.5,130.5C 553.557,129.391 553.89,128.391 554.5,127.5C 554.369,126.761 554.536,126.094 555,125.5C 556.751,124.778 558.251,123.778 559.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#646464",
    d: "M 146.5,124.5 C 146.332,127.051 145.332,127.718 143.5,126.5C 144.222,125.449 145.222,124.782 146.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#707070",
    d: "M 177.5,124.5 C 178.605,125.6 179.938,126.267 181.5,126.5C 179.291,127.976 177.958,127.309 177.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#646464",
    d: "M 392.5,124.5 C 392.332,127.051 391.332,127.718 389.5,126.5C 390.222,125.449 391.222,124.782 392.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#767676",
    d: "M 423.5,124.5 C 424.833,125.167 426.167,125.833 427.5,126.5C 425.559,127.679 424.226,127.013 423.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#6a6a6a",
    d: "M 493.5,124.5 C 493.443,125.609 493.11,126.609 492.5,127.5C 491.209,127.737 490.209,127.404 489.5,126.5C 491.062,126.267 492.395,125.6 493.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#626262",
    d: "M 522.5,124.5 C 523.778,124.782 524.778,125.449 525.5,126.5C 523.975,127.389 522.975,126.722 522.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#2e2e2e",
    d: "M 559.5,122.5 C 562.5,122.5 565.5,122.5 568.5,122.5C 568.715,124.179 568.048,125.179 566.5,125.5C 563.215,125.21 560.215,125.877 557.5,127.5C 558.502,125.989 559.169,124.322 559.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#5b5b5b",
    d: "M 568.5,122.5 C 571.916,124.248 574.25,126.914 575.5,130.5C 574.833,130.5 574.167,130.5 573.5,130.5C 572.5,130.5 571.5,130.5 570.5,130.5C 569.778,129.449 568.778,128.782 567.5,128.5C 567.5,128.167 567.5,127.833 567.5,127.5C 567.167,126.833 566.833,126.167 566.5,125.5C 568.048,125.179 568.715,124.179 568.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.282
    },
    fill: "#686868",
    d: "M 429.5,126.5 C 430.167,127.167 430.833,127.833 431.5,128.5C 431.44,129.043 431.107,129.376 430.5,129.5C 429.614,128.675 429.281,127.675 429.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#626262",
    d: "M 527.5,126.5 C 528.167,127.167 528.833,127.833 529.5,128.5C 529.44,129.043 529.107,129.376 528.5,129.5C 527.614,128.675 527.281,127.675 527.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.282
    },
    fill: "#747474",
    d: "M 140.5,127.5 C 139.7,129.741 138.034,130.741 135.5,130.5C 136.768,128.953 138.435,127.953 140.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#6b6b6b",
    d: "M 488.5,126.5 C 488.264,128.973 486.931,130.64 484.5,131.5C 483.893,131.376 483.56,131.043 483.5,130.5C 485.138,129.168 486.804,127.834 488.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.549
    },
    fill: "#474747",
    d: "M 37.5,125.5 C 37.5,126.167 37.5,126.833 37.5,127.5C 35.5272,130.139 33.1939,132.473 30.5,134.5C 30.5,133.167 30.5,131.833 30.5,130.5C 31.5,130.5 32.5,130.5 33.5,130.5C 33.5,129.5 33.5,128.5 33.5,127.5C 35.1993,127.473 36.5326,126.806 37.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.443
    },
    fill: "#656565",
    d: "M 386.5,126.5 C 386.264,128.973 384.931,130.64 382.5,131.5C 381.893,131.376 381.56,131.043 381.5,130.5C 383.138,129.168 384.804,127.834 386.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#777777",
    d: "M 530.5,128.5 C 532.798,129.797 534.798,131.463 536.5,133.5C 535.833,133.5 535.167,133.5 534.5,133.5C 532.457,132.421 531.124,130.754 530.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#8a8a8a",
    d: "M 566.5,125.5 C 566.833,126.167 567.167,126.833 567.5,127.5C 565.045,125.862 563.045,126.195 561.5,128.5C 561.307,132.566 561.64,136.566 562.5,140.5C 561.833,140.5 561.167,140.5 560.5,140.5C 560.167,139.5 559.5,138.833 558.5,138.5C 559.623,136.042 559.623,133.875 558.5,132C 561.037,128.094 560.37,127.594 556.5,130.5C 556.557,129.391 556.89,128.391 557.5,127.5C 560.215,125.877 563.215,125.21 566.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#555555",
    d: "M 561.5,128.5 C 563.167,128.5 564.833,128.5 566.5,128.5C 566.927,131.01 567.593,133.343 568.5,135.5C 568.5,136.833 568.5,138.167 568.5,139.5C 567.833,139.5 567.5,139.833 567.5,140.5C 565.876,140.64 564.71,139.973 564,138.5C 563.722,139.416 563.222,140.082 562.5,140.5C 561.64,136.566 561.307,132.566 561.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#727272",
    d: "M 268.5,128.5 C 273.678,132.007 277.344,136.674 279.5,142.5C 278.833,142.5 278.167,142.5 277.5,142.5C 276.489,140.628 275.655,138.628 275,136.5C 272.218,134.229 270.051,131.563 268.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#b5b6b5",
    d: "M 563.5,131.5 C 565.337,131.639 565.67,132.306 564.5,133.5C 563.702,133.043 563.369,132.376 563.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#5f5f5f",
    d: "M 182.5,126.5 C 193.17,131.746 201.003,139.746 206,150.5C 206.494,152.134 206.66,153.801 206.5,155.5C 205.833,154.167 205.167,152.833 204.5,151.5C 203.377,149.255 202.211,146.921 201,144.5C 194.885,138.215 188.718,132.215 182.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#777777",
    d: "M 433.5,130.5 C 436.172,130.948 438.172,132.281 439.5,134.5C 438.609,133.89 437.609,133.557 436.5,133.5C 435.167,132.833 434.167,131.833 433.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#919191",
    d: "M 566.5,128.5 C 566.833,128.5 567.167,128.5 567.5,128.5C 568.369,130.717 568.702,133.05 568.5,135.5C 567.593,133.343 566.927,131.01 566.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#757575",
    d: "M 229.5,128.5 C 227.833,130.5 226.167,132.5 224.5,134.5C 222.291,135.896 220.791,137.896 220,140.5C 218.941,144.739 218.108,148.739 217.5,152.5C 216.135,141.983 220.135,133.983 229.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#717171",
    d: "M 380.5,130.5 C 380.719,131.675 380.386,132.675 379.5,133.5C 375.488,136.515 371.822,139.848 368.5,143.5C 371.545,138.305 375.545,133.972 380.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#686868",
    d: "M 133.5,132.5 C 130.538,135.964 127.371,139.297 124,142.5C 123.51,143.793 123.343,145.127 123.5,146.5C 122.5,146.5 121.5,146.5 120.5,146.5C 123.191,140.318 127.525,135.652 133.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#787878",
    d: "M 479.5,133.5 C 478.404,136.386 476.404,138.386 473.5,139.5C 475.027,137.061 477.027,135.061 479.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#848484",
    d: "M 570.5,130.5 C 571.5,130.5 572.5,130.5 573.5,130.5C 574.258,135.249 572.925,139.249 569.5,142.5C 570,142.833 570.5,143.167 571,143.5C 572.123,141.9 573.623,140.9 575.5,140.5C 574.683,143.556 572.683,145.223 569.5,145.5C 568.694,144.272 567.694,143.272 566.5,142.5C 567.338,142.158 567.672,141.492 567.5,140.5C 567.5,139.833 567.833,139.5 568.5,139.5C 568.81,140.738 569.31,140.738 570,139.5C 572.882,136.499 573.049,133.499 570.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#434343",
    d: "M 29.5,135.5 C 28.7377,137.262 27.4044,138.262 25.5,138.5C 24.2267,137.923 24.2267,137.257 25.5,136.5C 26.7362,135.754 28.0695,135.421 29.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#757575",
    d: "M 554.5,127.5 C 553.89,128.391 553.557,129.391 553.5,130.5C 554.087,134.071 554.087,137.737 553.5,141.5C 552.784,139.444 552.117,137.277 551.5,135C 551.846,132.06 552.846,129.56 554.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#292929",
    d: "M 244.5,139.5 C 247.304,138.362 250.304,138.195 253.5,139C 255.596,139.737 257.263,140.903 258.5,142.5C 257.5,142.5 256.5,142.5 255.5,142.5C 253.801,142.473 252.467,141.806 251.5,140.5C 249.393,139.532 247.059,139.198 244.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#373737",
    d: "M 436.5,133.5 C 437.609,133.557 438.609,133.89 439.5,134.5C 440.931,135.082 442.264,135.915 443.5,137C 444.252,137.671 444.586,138.504 444.5,139.5C 444.5,140.167 444.5,140.833 444.5,141.5C 441.5,139.167 438.833,136.5 436.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.512
    },
    fill: "#3c3c3c",
    d: "M 21.5,139.5 C 22.8333,139.5 24.1667,139.5 25.5,139.5C 23.626,143.165 22.2927,143.165 21.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.737
    },
    fill: "#2f2f2f",
    d: "M 170.5,141.5 C 168.901,141.232 167.568,141.566 166.5,142.5C 165.167,142.5 163.833,142.5 162.5,142.5C 163.263,141.732 164.263,141.232 165.5,141C 162.833,140.333 160.167,140.333 157.5,141C 159.058,141.21 160.391,141.71 161.5,142.5C 159.833,142.5 158.167,142.5 156.5,142.5C 155.432,141.566 154.099,141.232 152.5,141.5C 158.5,138.833 164.5,138.833 170.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.506
    },
    fill: "#323232",
    d: "M 516.5,141.5 C 515.209,141.263 514.209,141.596 513.5,142.5C 512.833,142.5 512.167,142.5 511.5,142.5C 510.866,141.053 509.699,140.387 508,140.5C 506.301,140.387 505.134,141.053 504.5,142.5C 503.5,142.5 502.5,142.5 501.5,142.5C 500.791,141.596 499.791,141.263 498.5,141.5C 504.5,138.833 510.5,138.833 516.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#616161",
    d: "M 534.5,133.5 C 535.167,133.5 535.833,133.5 536.5,133.5C 539.815,135.821 542.482,138.821 544.5,142.5C 540.605,140.28 537.272,137.28 534.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#747474",
    d: "M 556.5,135.5 C 556.285,137.179 556.952,138.179 558.5,138.5C 558.5,139.167 558.5,139.833 558.5,140.5C 557.5,140.5 556.5,140.5 555.5,140.5C 555.216,138.585 555.549,136.919 556.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.549
    },
    fill: "#323232",
    d: "M 573.5,130.5 C 574.167,130.5 574.833,130.5 575.5,130.5C 575.5,133.833 575.5,137.167 575.5,140.5C 573.623,140.9 572.123,141.9 571,143.5C 570.5,143.167 570,142.833 569.5,142.5C 572.925,139.249 574.258,135.249 573.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#5d5d5d",
    d: "M 162.5,142.5 C 162.167,142.5 161.833,142.5 161.5,142.5C 160.391,141.71 159.058,141.21 157.5,141C 160.167,140.333 162.833,140.333 165.5,141C 164.263,141.232 163.263,141.732 162.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#787878",
    d: "M 244.5,139.5 C 247.059,139.198 249.393,139.532 251.5,140.5C 248.248,140.29 245.248,140.956 242.5,142.5C 242.427,140.973 243.094,139.973 244.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#343434",
    d: "M 556.5,133.5 C 556.5,134.167 556.5,134.833 556.5,135.5C 555.549,136.919 555.216,138.585 555.5,140.5C 556.5,140.5 557.5,140.5 558.5,140.5C 558.833,140.5 559.167,140.5 559.5,140.5C 559.34,142.153 558.674,143.486 557.5,144.5C 555.596,144.262 554.262,143.262 553.5,141.5C 554.087,137.737 554.087,134.071 553.5,130.5C 554.117,130.389 554.617,130.056 555,129.5C 555.21,131.058 555.71,132.391 556.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.702
    },
    fill: "#414141",
    d: "M 170.5,141.5 C 172.403,141.796 174.07,142.463 175.5,143.5C 174.508,143.328 173.842,143.662 173.5,144.5C 172.833,144.5 172.167,144.5 171.5,144.5C 171.443,143.391 171.11,142.391 170.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#808080",
    d: "M 398.5,141.5 C 399.791,141.263 400.791,141.596 401.5,142.5C 400.167,143.167 398.833,143.833 397.5,144.5C 397.263,143.209 397.596,142.209 398.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#383838",
    d: "M 412.5,142.5 C 408.833,142.5 405.167,142.5 401.5,142.5C 400.791,141.596 399.791,141.263 398.5,141.5C 402.89,139.627 407.556,139.127 412.5,140C 413.598,140.77 413.598,141.603 412.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#727272",
    d: "M 511.5,142.5 C 509.167,142.5 506.833,142.5 504.5,142.5C 505.134,141.053 506.301,140.387 508,140.5C 509.699,140.387 510.866,141.053 511.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#898989",
    d: "M 166.5,142.5 C 167.568,141.566 168.901,141.232 170.5,141.5C 171.11,142.391 171.443,143.391 171.5,144.5C 169.95,143.559 168.284,142.893 166.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#6b6b6b",
    d: "M 255.5,142.5 C 256.5,142.5 257.5,142.5 258.5,142.5C 259.686,143.961 259.686,145.295 258.5,146.5C 257.789,144.97 256.789,143.637 255.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.404
    },
    fill: "#424242",
    d: "M 498.5,141.5 C 497.9,142.9 496.9,143.9 495.5,144.5C 495.672,145.492 495.338,146.158 494.5,146.5C 494.5,145.167 494.5,143.833 494.5,142.5C 495.959,142.567 497.292,142.234 498.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#707070",
    d: "M 513.5,142.5 C 514.209,141.596 515.209,141.263 516.5,141.5C 517.906,141.973 518.573,142.973 518.5,144.5C 516.989,143.498 515.322,142.831 513.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.552
    },
    fill: "#252525",
    d: "M 561.5,142.5 C 563.167,142.5 564.833,142.5 566.5,142.5C 567.694,143.272 568.694,144.272 569.5,145.5C 569.158,146.338 568.492,146.672 567.5,146.5C 564.972,145.834 562.306,145.168 559.5,144.5C 560.243,143.818 560.909,143.151 561.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#808080",
    d: "M 498.5,141.5 C 499.791,141.263 500.791,141.596 501.5,142.5C 499.718,143.72 497.718,144.386 495.5,144.5C 496.9,143.9 497.9,142.9 498.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#747474",
    d: "M 395.5,144.5 C 394.127,146.207 392.461,147.54 390.5,148.5C 390.5,147.833 390.5,147.167 390.5,146.5C 391.823,144.318 393.49,143.651 395.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#767676",
    d: "M 559.5,140.5 C 559.833,140.5 560.167,140.5 560.5,140.5C 560.328,141.492 560.662,142.158 561.5,142.5C 560.909,143.151 560.243,143.818 559.5,144.5C 562.306,145.168 564.972,145.834 567.5,146.5C 566.417,146.539 565.417,146.873 564.5,147.5C 561.655,147.234 559.322,146.234 557.5,144.5C 558.674,143.486 559.34,142.153 559.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#656565",
    d: "M 175.5,143.5 C 179.618,146.281 182.618,149.948 184.5,154.5C 180.879,151.217 177.213,147.884 173.5,144.5C 173.842,143.662 174.508,143.328 175.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#777777",
    d: "M 473.5,139.5 C 472.973,142.231 472.14,144.898 471,147.5C 470.241,149.063 469.074,150.063 467.5,150.5C 469.262,146.638 471.262,142.972 473.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.855
    },
    fill: "#1e1e1e",
    d: "M 224.5,134.5 C 220.085,142.149 219.418,150.149 222.5,158.5C 220.356,156.867 218.689,154.867 217.5,152.5C 218.108,148.739 218.941,144.739 220,140.5C 220.791,137.896 222.291,135.896 224.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#727272",
    d: "M 444.5,139.5 C 449.406,144.647 452.739,150.647 454.5,157.5C 453.609,156.89 452.609,156.557 451.5,156.5C 451.662,154.473 451.495,152.473 451,150.5C 447.842,148.136 445.676,145.136 444.5,141.5C 444.5,140.833 444.5,140.167 444.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#7b7b7b",
    d: "M 544.5,142.5 C 546.088,144.113 547.088,146.113 547.5,148.5C 546.833,148.5 546.167,148.5 545.5,148.5C 544.85,146.565 544.517,144.565 544.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#7a7a7a",
    d: "M 41.5,148.5 C 55.8333,148.5 70.1667,148.5 84.5,148.5C 84.6602,150.199 84.4935,151.866 84,153.5C 83.124,155.758 81.9573,157.758 80.5,159.5C 79.8333,159.5 79.5,159.167 79.5,158.5C 80.7298,156.703 81.3964,154.703 81.5,152.5C 82.4778,152.189 83.1445,151.522 83.5,150.5C 69.8496,149.501 56.1829,149.167 42.5,149.5C 41.8333,149.5 41.5,149.167 41.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#262626",
    d: "M 277.5,142.5 C 278.167,142.5 278.833,142.5 279.5,142.5C 280.404,143.209 280.737,144.209 280.5,145.5C 279.566,146.568 279.232,147.901 279.5,149.5C 273.31,149.823 267.31,149.49 261.5,148.5C 267.167,148.5 272.833,148.5 278.5,148.5C 278.483,146.435 278.15,144.435 277.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#020202",
    d: "M 41.5,148.5 C 41.5,149.167 41.8333,149.5 42.5,149.5C 55.6988,149.84 68.6988,150.84 81.5,152.5C 81.3964,154.703 80.7298,156.703 79.5,158.5C 76.9397,161.22 73.9397,163.386 70.5,165C 69.6634,166.011 69.33,167.178 69.5,168.5C 68.8333,168.5 68.1667,168.5 67.5,168.5C 59.0161,167.507 50.3494,167.174 41.5,167.5C 40.8826,167.611 40.3826,167.944 40,168.5C 38.6986,176.539 39.532,184.206 42.5,191.5C 43.2625,192.268 44.2625,192.768 45.5,193C 59.8295,193.5 74.1628,193.667 88.5,193.5C 89.1667,193.5 89.8333,193.5 90.5,193.5C 91.791,193.737 92.791,193.404 93.5,192.5C 94.4916,192.328 95.1583,192.662 95.5,193.5C 97.4003,196.249 99.567,198.916 102,201.5C 102.813,203.436 103.313,205.436 103.5,207.5C 103.167,208.167 102.833,208.833 102.5,209.5C 79.1511,209.747 55.8178,209.414 32.5,208.5C 28.0227,205.032 24.356,201.032 21.5,196.5C 21.5,186.833 21.5,177.167 21.5,167.5C 28.5,162.5 34.5,156.5 39.5,149.5C 39.8417,148.662 40.5084,148.328 41.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#242424",
    d: "M 42.5,149.5 C 56.1829,149.167 69.8496,149.501 83.5,150.5C 83.1445,151.522 82.4778,152.189 81.5,152.5C 68.6988,150.84 55.6988,149.84 42.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#737373",
    d: "M 280.5,145.5 C 280.5,147.167 280.5,148.833 280.5,150.5C 273.492,150.666 266.492,150.5 259.5,150C 258.748,149.329 258.414,148.496 258.5,147.5C 259.391,148.11 260.391,148.443 261.5,148.5C 267.31,149.49 273.31,149.823 279.5,149.5C 279.232,147.901 279.566,146.568 280.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#323232",
    d: "M 390.5,146.5 C 390.5,147.167 390.5,147.833 390.5,148.5C 390.167,149.5 389.5,150.167 388.5,150.5C 387.5,150.5 386.5,150.5 385.5,150.5C 387.142,149.197 388.809,147.864 390.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#737373",
    d: "M 241.5,142.5 C 237.945,145.503 237.612,148.836 240.5,152.5C 239.504,152.586 238.671,152.252 238,151.5C 237.333,148.833 237.333,146.167 238,143.5C 239.041,141.689 240.207,141.355 241.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#737373",
    d: "M 120.5,146.5 C 118.955,150.71 117.955,155.043 117.5,159.5C 116.833,159.5 116.167,159.5 115.5,159.5C 116.07,154.643 117.736,150.31 120.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#595959",
    d: "M 152.5,141.5 C 154.099,141.232 155.432,141.566 156.5,142.5C 145.041,145.546 138.374,152.879 136.5,164.5C 135.883,164.389 135.383,164.056 135,163.5C 134.833,165 134.667,166.5 134.5,168C 134.569,169.986 135.235,171.486 136.5,172.5C 136.5,173.167 136.5,173.833 136.5,174.5C 135.504,174.586 134.671,174.252 134,173.5C 131.716,157.78 137.883,147.113 152.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#7a7a7a",
    d: "M 547.5,148.5 C 548.249,151.201 549.249,153.868 550.5,156.5C 547.828,154.609 546.828,151.942 547.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25
    },
    fill: "#737373",
    d: "M 519.5,144.5 C 519.56,143.957 519.893,143.624 520.5,143.5C 524.345,146.331 527.345,149.664 529.5,153.5C 529.737,154.791 529.404,155.791 528.5,156.5C 526.656,151.653 523.656,147.653 519.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#808080",
    d: "M 432.5,155.5 C 434.339,161.354 435.339,167.354 435.5,173.5C 434.791,174.404 433.791,174.737 432.5,174.5C 433.295,172.066 433.962,169.899 434.5,168C 432.142,163.487 430.642,158.987 430,154.5C 426.169,149.158 421.336,145.158 415.5,142.5C 415.735,141.903 416.235,141.57 417,141.5C 418.964,142.852 421.131,143.686 423.5,144C 427.531,147.178 430.531,151.011 432.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#5d5d5d",
    d: "M 493.5,147.5 C 489.065,151.896 486.732,157.23 486.5,163.5C 485.844,162.378 485.511,161.045 485.5,159.5C 485.24,153.307 487.907,149.307 493.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.302
    },
    fill: "#3f3f3f",
    d: "M 204.5,151.5 C 205.167,152.833 205.833,154.167 206.5,155.5C 207.906,155.973 208.573,156.973 208.5,158.5C 207.325,158.719 206.325,158.386 205.5,157.5C 204.652,155.591 204.318,153.591 204.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#767676",
    d: "M 250.5,156.5 C 252.011,157.502 253.678,158.169 255.5,158.5C 254.399,159.598 253.066,159.765 251.5,159C 250.748,158.329 250.414,157.496 250.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.235
    },
    fill: "#898989",
    d: "M 184.5,154.5 C 187.144,156.412 187.81,158.745 186.5,161.5C 185.067,159.442 184.4,157.108 184.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#7c7c7c",
    d: "M 368.5,143.5 C 367.03,146.318 366.03,149.318 365.5,152.5C 364.127,155.566 362.46,158.566 360.5,161.5C 361.86,158.38 362.693,155.047 363,151.5C 364.102,148.285 365.935,145.618 368.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#6a6a6a",
    d: "M 385.5,150.5 C 386.5,150.5 387.5,150.5 388.5,150.5C 385.754,154.474 383.754,158.808 382.5,163.5C 381.566,162.432 381.232,161.099 381.5,159.5C 382.827,156.529 384.16,153.529 385.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.549
    },
    fill: "#343434",
    d: "M 240.5,152.5 C 242.31,153.908 244.31,155.075 246.5,156C 247.793,156.49 249.127,156.657 250.5,156.5C 250.414,157.496 250.748,158.329 251.5,159C 253.066,159.765 254.399,159.598 255.5,158.5C 255.833,158.5 256.167,158.5 256.5,158.5C 257.167,159.5 257.833,160.5 258.5,161.5C 252.522,159.879 246.522,158.212 240.5,156.5C 240.5,155.167 240.5,153.833 240.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#666666",
    d: "M 256.5,158.5 C 258.322,158.831 259.989,159.498 261.5,160.5C 260.791,161.404 259.791,161.737 258.5,161.5C 257.833,160.5 257.167,159.5 256.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#313131",
    d: "M 529.5,153.5 C 530.407,155.657 531.073,157.99 531.5,160.5C 530.883,160.611 530.383,160.944 530,161.5C 529.768,160.263 529.268,159.263 528.5,158.5C 528.5,157.833 528.5,157.167 528.5,156.5C 529.404,155.791 529.737,154.791 529.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#7a7a7a",
    d: "M 217.5,152.5 C 218.689,154.867 220.356,156.867 222.5,158.5C 222.5,159.833 222.5,161.167 222.5,162.5C 219.827,159.822 218.161,156.488 217.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.516
    },
    fill: "#333333",
    d: "M 79.5,158.5 C 79.5,159.167 79.8333,159.5 80.5,159.5C 79.8333,162.167 78.1667,163.833 75.5,164.5C 74.0048,164.989 72.6715,165.655 71.5,166.5C 71.5,167.833 70.8333,168.5 69.5,168.5C 69.33,167.178 69.6634,166.011 70.5,165C 73.9397,163.386 76.9397,161.22 79.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6c6c6c",
    d: "M 466.5,153.5 C 467.461,155.265 467.795,157.265 467.5,159.5C 466.732,160.263 466.232,161.263 466,162.5C 465.333,178.167 465.333,193.833 466,209.5C 466.278,210.416 466.778,211.082 467.5,211.5C 467.5,211.833 467.5,212.167 467.5,212.5C 466.504,212.586 465.671,212.252 465,211.5C 464.333,194.167 464.333,176.833 465,159.5C 466.128,157.655 466.628,155.655 466.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.235
    },
    fill: "#919191",
    d: "M 550.5,159.5 C 551.153,177.532 550.486,195.198 548.5,212.5C 549.154,194.735 549.821,177.069 550.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#313131",
    d: "M 115.5,159.5 C 116.167,159.5 116.833,159.5 117.5,159.5C 117.167,161.5 116.833,163.5 116.5,165.5C 115.833,189.5 115.167,213.5 114.5,237.5C 114.169,211.328 114.502,185.328 115.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#5a5a5a",
    d: "M 264.5,160.5 C 265.778,160.782 266.778,161.449 267.5,162.5C 265.975,163.389 264.975,162.722 264.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#3d3d3d",
    d: "M 467.5,159.5 C 467.5,176.5 467.5,193.5 467.5,210.5C 467.5,210.833 467.5,211.167 467.5,211.5C 466.778,211.082 466.278,210.416 466,209.5C 465.333,193.833 465.333,178.167 466,162.5C 466.232,161.263 466.732,160.263 467.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#727272",
    d: "M 528.5,158.5 C 529.268,159.263 529.768,160.263 530,161.5C 530.383,160.944 530.883,160.611 531.5,160.5C 531.181,177.91 531.515,195.244 532.5,212.5C 530.11,212.315 529.11,210.982 529.5,208.5C 529.339,193.899 529.672,179.399 530.5,165C 528.984,163.103 528.317,160.936 528.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#242424",
    d: "M 545.5,148.5 C 546.167,148.5 546.833,148.5 547.5,148.5C 546.828,151.942 547.828,154.609 550.5,156.5C 550.5,157.5 550.5,158.5 550.5,159.5C 549.821,177.069 549.154,194.735 548.5,212.5C 543.167,212.5 537.833,212.5 532.5,212.5C 531.515,195.244 531.181,177.91 531.5,160.5C 532.496,176.658 532.83,192.991 532.5,209.5C 537.833,209.5 543.167,209.5 548.5,209.5C 548.667,192.497 548.5,175.497 548,158.5C 546.844,155.276 546.01,151.943 545.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.549
    },
    fill: "#292929",
    d: "M 365.5,152.5 C 364.777,155.822 363.943,159.155 363,162.5C 362.658,164.619 361.825,164.953 360.5,163.5C 360.5,162.833 360.5,162.167 360.5,161.5C 362.46,158.566 364.127,155.566 365.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#797979",
    d: "M 39.5,149.5 C 34.5,156.5 28.5,162.5 21.5,167.5C 27.1396,161.194 33.1396,155.194 39.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#565656",
    d: "M 188.5,173.5 C 188.665,170.482 188.498,167.482 188,164.5C 187.722,165.416 187.222,166.082 186.5,166.5C 186.5,165.5 186.5,164.5 186.5,163.5C 187.15,163.196 187.817,162.863 188.5,162.5C 189.808,166.315 189.808,169.981 188.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#494949",
    d: "M 268.5,162.5 C 270.027,162.427 271.027,163.094 271.5,164.5C 270.791,165.404 269.791,165.737 268.5,165.5C 268.5,164.5 268.5,163.5 268.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#808080",
    d: "M 75.5,164.5 C 74.8166,166.176 73.4832,166.843 71.5,166.5C 72.6715,165.655 74.0048,164.989 75.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.427
    },
    fill: "#242424",
    d: "M 116.5,165.5 C 116.5,189.833 116.5,214.167 116.5,238.5C 120.115,238.845 123.448,238.178 126.5,236.5C 126.167,237.167 125.833,237.833 125.5,238.5C 125.5,239.833 124.833,240.5 123.5,240.5C 122.903,239.861 122.07,239.528 121,239.5C 119.624,239.684 118.791,240.351 118.5,241.5C 117.167,241.5 115.833,241.5 114.5,241.5C 114.5,240.167 114.5,238.833 114.5,237.5C 115.167,213.5 115.833,189.5 116.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#2f2f2f",
    d: "M 432.5,155.5 C 433.973,157.583 435.14,159.916 436,162.5C 436.81,166.358 436.643,170.024 435.5,173.5C 435.339,167.354 434.339,161.354 432.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.235
    },
    fill: "#7e7e7e",
    d: "M 136.5,164.5 C 136.5,167.167 136.5,169.833 136.5,172.5C 135.235,171.486 134.569,169.986 134.5,168C 134.667,166.5 134.833,165 135,163.5C 135.383,164.056 135.883,164.389 136.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#666666",
    d: "M 223.5,162.5 C 224.552,162.351 225.552,162.517 226.5,163C 229.174,166.332 232.507,168.665 236.5,170C 237.252,170.671 237.586,171.504 237.5,172.5C 234.554,171.027 231.554,169.527 228.5,168C 226.263,166.6 224.596,164.767 223.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#2d2d2d",
    d: "M 381.5,159.5 C 381.232,161.099 381.566,162.432 382.5,163.5C 382.5,166.167 382.5,168.833 382.5,171.5C 381.566,172.568 381.232,173.901 381.5,175.5C 378.925,170.155 378.925,164.821 381.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#3c3c3c",
    d: "M 451.5,156.5 C 452.609,156.557 453.609,156.89 454.5,157.5C 454.5,164.5 454.5,171.5 454.5,178.5C 453.5,179.167 452.5,179.833 451.5,180.5C 452.833,172.5 452.833,164.5 451.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#767676",
    d: "M 41.5,167.5 C 50.3494,167.174 59.0161,167.507 67.5,168.5C 59.1667,168.5 50.8333,168.5 42.5,168.5C 42.5,169.833 42.5,171.167 42.5,172.5C 41.5489,171.081 41.2155,169.415 41.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#797979",
    d: "M 188.5,173.5 C 188.634,175.292 188.301,176.958 187.5,178.5C 186.143,179.59 185.143,180.924 184.5,182.5C 184.104,179.956 184.771,177.789 186.5,176C 186.322,173.045 186.322,169.879 186.5,166.5C 187.222,166.082 187.722,165.416 188,164.5C 188.498,167.482 188.665,170.482 188.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#737373",
    d: "M 272.5,164.5 C 275.949,166.941 278.616,169.941 280.5,173.5C 277.126,171.126 274.459,168.126 272.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.302
    },
    fill: "#414141",
    d: "M 41.5,167.5 C 41.2155,169.415 41.5489,171.081 42.5,172.5C 42.334,177.844 42.5006,183.177 43,188.5C 43.4169,189.756 44.2502,190.423 45.5,190.5C 45.5,190.833 45.5,191.167 45.5,191.5C 44.5,191.5 43.5,191.5 42.5,191.5C 39.532,184.206 38.6986,176.539 40,168.5C 40.3826,167.944 40.8826,167.611 41.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#767676",
    d: "M 239.5,172.5 C 240.209,171.596 241.209,171.263 242.5,171.5C 242.5,172.5 242.5,173.5 242.5,174.5C 241.778,173.449 240.778,172.782 239.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#6f6f6f",
    d: "M 245.5,174.5 C 248.113,173.007 250.113,173.674 251.5,176.5C 249.5,175.833 247.5,175.167 245.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#333333",
    d: "M 363.5,176.5 C 362.222,176.218 361.222,175.551 360.5,174.5C 360.5,173.833 360.5,173.167 360.5,172.5C 361.117,172.389 361.617,172.056 362,171.5C 362.608,173.154 363.108,174.821 363.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#7c7c7c",
    d: "M 253.5,176.5 C 254.209,175.596 255.209,175.263 256.5,175.5C 257.11,176.391 257.443,177.391 257.5,178.5C 256.395,177.4 255.062,176.733 253.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#848484",
    d: "M 382.5,171.5 C 382.4,174.108 383.067,176.442 384.5,178.5C 383.5,178.5 382.5,178.5 381.5,178.5C 381.5,177.5 381.5,176.5 381.5,175.5C 381.232,173.901 381.566,172.568 382.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#808080",
    d: "M 360.5,174.5 C 361.222,175.551 362.222,176.218 363.5,176.5C 363.29,179.752 363.956,182.752 365.5,185.5C 365.5,186.167 365.167,186.5 364.5,186.5C 362.956,182.557 361.623,178.557 360.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#7f7f7f",
    d: "M 432.5,175.5 C 434.213,179.748 432.88,182.748 428.5,184.5C 430.223,181.66 431.557,178.66 432.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#7e7e7e",
    d: "M 136.5,175.5 C 138.3,180.314 140.967,184.648 144.5,188.5C 143.448,188.649 142.448,188.483 141.5,188C 139.001,184.755 137.001,181.255 135.5,177.5C 135.543,176.584 135.876,175.917 136.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.559
    },
    fill: "#2c2c2c",
    d: "M 256.5,175.5 C 263.712,178.242 266.046,183.242 263.5,190.5C 264.055,186.988 263.388,183.988 261.5,181.5C 260.363,180.211 259.03,179.211 257.5,178.5C 257.443,177.391 257.11,176.391 256.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6e6e6e",
    d: "M 280.5,173.5 C 281.117,173.611 281.617,173.944 282,174.5C 282.888,178.027 283.722,181.527 284.5,185C 284.591,187.775 283.924,190.275 282.5,192.5C 281.861,191.903 281.528,191.07 281.5,190C 282.643,187.178 283.309,184.511 283.5,182C 282.956,181.283 282.289,180.783 281.5,180.5C 281.326,178.139 280.993,175.806 280.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#838383",
    d: "M 454.5,178.5 C 453.753,181.587 452.42,184.254 450.5,186.5C 451.341,184.621 451.675,182.621 451.5,180.5C 452.5,179.833 453.5,179.167 454.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#383838",
    d: "M 187.5,178.5 C 187.275,181.546 185.942,183.879 183.5,185.5C 183.557,184.391 183.89,183.391 184.5,182.5C 185.143,180.924 186.143,179.59 187.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#474747",
    d: "M 381.5,178.5 C 382.5,178.5 383.5,178.5 384.5,178.5C 384.5,179.167 384.5,179.833 384.5,180.5C 384.833,181.833 385.167,183.167 385.5,184.5C 383.99,182.678 382.657,180.678 381.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.235
    },
    fill: "#848484",
    d: "M 239.5,191.5 C 238.883,191.611 238.383,191.944 238,192.5C 237.764,190.881 236.931,189.881 235.5,189.5C 235.5,188.167 235.5,186.833 235.5,185.5C 229.31,185.177 223.31,185.51 217.5,186.5C 217.5,187.167 217.5,187.833 217.5,188.5C 217.737,189.791 217.404,190.791 216.5,191.5C 216.5,189.167 216.5,186.833 216.5,184.5C 223.167,184.5 229.833,184.5 236.5,184.5C 236.681,187.195 237.681,189.528 239.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#747474",
    d: "M 184.5,182.5 C 183.89,183.391 183.557,184.391 183.5,185.5C 182.599,187.727 180.933,188.727 178.5,188.5C 180.215,186.118 182.215,184.118 184.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25
    },
    fill: "#747474",
    d: "M 208.5,178.5 C 206.425,184.154 203.758,189.487 200.5,194.5C 200.833,193.167 201.167,191.833 201.5,190.5C 203.958,186.909 205.291,182.909 205.5,178.5C 206.5,178.5 207.5,178.5 208.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.774
    },
    fill: "#272727",
    d: "M 217.5,186.5 C 223.31,185.51 229.31,185.177 235.5,185.5C 235.5,186.833 235.5,188.167 235.5,189.5C 234.596,188.791 234.263,187.791 234.5,186.5C 228.833,186.5 223.167,186.5 217.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#292929",
    d: "M 281.5,180.5 C 282.289,180.783 282.956,181.283 283.5,182C 283.309,184.511 282.643,187.178 281.5,190C 281.528,191.07 281.861,191.903 282.5,192.5C 282.5,193.167 282.5,193.833 282.5,194.5C 280.616,195.339 279.283,196.672 278.5,198.5C 280.144,192.638 281.144,186.638 281.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#787878",
    d: "M 384.5,180.5 C 386.737,183.745 389.403,186.745 392.5,189.5C 395.886,191.193 399.22,192.86 402.5,194.5C 395.559,193.891 389.892,190.558 385.5,184.5C 385.167,183.167 384.833,181.833 384.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25
    },
    fill: "#636363",
    d: "M 428.5,184.5 C 428.579,185.93 428.246,187.264 427.5,188.5C 425.383,190.721 422.883,192.387 420,193.5C 419.235,193.43 418.735,193.097 418.5,192.5C 422.188,190.317 425.521,187.65 428.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#909090",
    d: "M 145.5,188.5 C 146.167,189.167 146.833,189.833 147.5,190.5C 147.44,191.043 147.107,191.376 146.5,191.5C 145.614,190.675 145.281,189.675 145.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#2e2e2e",
    d: "M 45.5,191.5 C 45.5,191.167 45.5,190.833 45.5,190.5C 59.8333,190.5 74.1667,190.5 88.5,190.5C 89.1667,191.5 89.8333,192.5 90.5,193.5C 89.8333,193.5 89.1667,193.5 88.5,193.5C 87.469,192.751 86.3024,192.085 85,191.5C 72.0009,192.168 58.8342,192.168 45.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#1b1b1b",
    d: "M 42.5,191.5 C 43.5,191.5 44.5,191.5 45.5,191.5C 58.8342,192.168 72.0009,192.168 85,191.5C 86.3024,192.085 87.469,192.751 88.5,193.5C 74.1628,193.667 59.8295,193.5 45.5,193C 44.2625,192.768 43.2625,192.268 42.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6c6c6c",
    d: "M 88.5,190.5 C 90.3224,190.831 91.9891,191.498 93.5,192.5C 92.791,193.404 91.791,193.737 90.5,193.5C 89.8333,192.5 89.1667,191.5 88.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#848484",
    d: "M 148.5,190.5 C 149.5,191.167 150.5,191.833 151.5,192.5C 149.668,193.718 148.668,193.051 148.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#6a6a6a",
    d: "M 261.5,181.5 C 263.388,183.988 264.055,186.988 263.5,190.5C 262.067,191.833 260.733,193.333 259.5,195C 258.563,195.692 257.897,195.525 257.5,194.5C 259.144,192.471 260.811,190.305 262.5,188C 262.661,185.928 262.328,183.761 261.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#888888",
    d: "M 152.5,192.5 C 153.778,192.782 154.778,193.449 155.5,194.5C 155.158,195.338 154.492,195.672 153.5,195.5C 152.89,194.609 152.557,193.609 152.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#3f3f3f",
    d: "M 217.5,188.5 C 218.458,190.302 219.125,192.302 219.5,194.5C 218.833,194.5 218.167,194.5 217.5,194.5C 216.596,193.791 216.263,192.791 216.5,191.5C 217.404,190.791 217.737,189.791 217.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#595959",
    d: "M 365.5,185.5 C 368.48,188.507 370.147,192.174 370.5,196.5C 369.113,193.947 367.28,191.614 365,189.5C 364.517,188.552 364.351,187.552 364.5,186.5C 365.167,186.5 365.5,186.167 365.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#7e7e7e",
    d: "M 177.5,188.5 C 177.5,189.5 177.5,190.5 177.5,191.5C 174.626,192.097 172.292,193.431 170.5,195.5C 169.209,195.737 168.209,195.404 167.5,194.5C 170.833,192.5 174.167,190.5 177.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.302
    },
    fill: "#3e3e3e",
    d: "M 201.5,190.5 C 201.167,191.833 200.833,193.167 200.5,194.5C 200.5,195.167 200.167,195.5 199.5,195.5C 198.833,195.5 198.167,195.5 197.5,195.5C 198.834,193.804 200.168,192.138 201.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#868686",
    d: "M 416.5,192.5 C 416.332,195.051 415.332,195.718 413.5,194.5C 414.5,193.833 415.5,193.167 416.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.694
    },
    fill: "#1f1f1f",
    d: "M 155.5,194.5 C 159.5,194.5 163.5,194.5 167.5,194.5C 168.209,195.404 169.209,195.737 170.5,195.5C 164.819,198.007 159.152,198.007 153.5,195.5C 154.492,195.672 155.158,195.338 155.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.459
    },
    fill: "#343434",
    d: "M 240.5,192.5 C 242.721,193.638 244.721,194.972 246.5,196.5C 248.948,197.473 251.615,197.806 254.5,197.5C 251.696,198.638 248.696,198.805 245.5,198C 242.293,197.428 240.626,195.595 240.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#707070",
    d: "M 217.5,194.5 C 218.167,194.5 218.833,194.5 219.5,194.5C 220.5,197.333 221.833,200 223.5,202.5C 222.5,202.5 221.5,202.5 220.5,202.5C 219.151,199.654 218.151,196.988 217.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#777777",
    d: "M 255.5,194.5 C 254.89,195.391 254.557,196.391 254.5,197.5C 251.615,197.806 248.948,197.473 246.5,196.5C 249.785,196.79 252.785,196.123 255.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#777777",
    d: "M 282.5,194.5 C 280.201,199.797 276.534,203.797 271.5,206.5C 271.833,205.833 272.167,205.167 272.5,204.5C 274.861,202.806 276.861,200.806 278.5,198.5C 279.283,196.672 280.616,195.339 282.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#616161",
    d: "M 371.5,197.5 C 373.867,198.164 375.867,199.497 377.5,201.5C 378.386,202.325 378.719,203.325 378.5,204.5C 375.833,202.5 373.5,200.167 371.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#7e7e7e",
    d: "M 450.5,186.5 C 447.805,194.542 442.805,200.875 435.5,205.5C 435.557,204.391 435.89,203.391 436.5,202.5C 442.293,198.048 446.959,192.715 450.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#7c7c7c",
    d: "M 197.5,195.5 C 198.167,195.5 198.833,195.5 199.5,195.5C 196.483,199.85 192.817,203.517 188.5,206.5C 191.051,202.601 194.051,198.934 197.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#696969",
    d: "M 95.5,193.5 C 102.954,197.625 106.62,203.958 106.5,212.5C 105.5,212.5 104.5,212.5 103.5,212.5C 105.957,210.668 105.957,209.001 103.5,207.5C 103.313,205.436 102.813,203.436 102,201.5C 99.567,198.916 97.4003,196.249 95.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.302
    },
    fill: "#383838",
    d: "M 140.5,205.5 C 139.5,205.5 138.5,205.5 137.5,205.5C 137.103,204.475 136.437,204.308 135.5,205C 137,213.244 136.667,221.411 134.5,229.5C 133.609,230.11 132.609,230.443 131.5,230.5C 133.148,221.303 133.981,211.97 134,202.5C 136.839,201.664 139.005,202.664 140.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.512
    },
    fill: "#505050",
    d: "M 297.5,196.5 C 297.833,196.5 298.167,196.5 298.5,196.5C 299.011,198.195 299.678,199.861 300.5,201.5C 303.926,203.92 306.592,206.92 308.5,210.5C 302.707,208.376 299.04,204.376 297.5,198.5C 297.5,197.833 297.5,197.167 297.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.886
    },
    fill: "#2a2a2a",
    d: "M 223.5,202.5 C 225.558,203.933 227.892,204.6 230.5,204.5C 230.5,205.5 230.5,206.5 230.5,207.5C 229.391,207.443 228.391,207.11 227.5,206.5C 225.5,205.833 224.167,204.5 223.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#6d6d6d",
    d: "M 384.5,208.5 C 382.581,207.388 380.914,206.054 379.5,204.5C 379.56,203.957 379.893,203.624 380.5,203.5C 382.931,204.36 384.264,206.027 384.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#6a6a6a",
    d: "M 21.5,196.5 C 24.356,201.032 28.0227,205.032 32.5,208.5C 32.5,209.167 32.5,209.833 32.5,210.5C 29.2424,208.249 26.2424,205.583 23.5,202.5C 22.2319,200.696 21.5652,198.696 21.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#686868",
    d: "M 137.5,205.5 C 138.5,205.5 139.5,205.5 140.5,205.5C 142.893,206.353 144.226,208.019 144.5,210.5C 142.258,208.673 139.925,207.006 137.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6c6c6c",
    d: "M 187.5,206.5 C 185.715,208.134 183.715,209.468 181.5,210.5C 182.388,208.191 184.054,206.524 186.5,205.5C 187.107,205.624 187.44,205.957 187.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.694
    },
    fill: "#1a1a1a",
    d: "M 32.5,208.5 C 55.8178,209.414 79.1511,209.747 102.5,209.5C 81.0064,210.497 59.3398,210.831 37.5,210.5C 36.1667,209.167 34.8333,209.167 33.5,210.5C 33.1667,210.5 32.8333,210.5 32.5,210.5C 32.5,209.833 32.5,209.167 32.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.373
    },
    fill: "#2e2e2e",
    d: "M 103.5,207.5 C 105.957,209.001 105.957,210.668 103.5,212.5C 82.1667,212.5 60.8333,212.5 39.5,212.5C 38.8333,211.833 38.1667,211.167 37.5,210.5C 59.3398,210.831 81.0064,210.497 102.5,209.5C 102.833,208.833 103.167,208.167 103.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#737373",
    d: "M 227.5,206.5 C 228.391,207.11 229.391,207.443 230.5,207.5C 231.906,207.973 232.573,208.973 232.5,210.5C 230.323,209.721 228.656,208.387 227.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#787878",
    d: "M 385.5,208.5 C 387.027,208.427 388.027,209.094 388.5,210.5C 386.973,210.573 385.973,209.906 385.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#4a4a4a",
    d: "M 436.5,202.5 C 435.89,203.391 435.557,204.391 435.5,205.5C 432.795,207.633 429.795,209.3 426.5,210.5C 426.414,209.504 426.748,208.671 427.5,208C 430.646,206.343 433.646,204.509 436.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6c6c6c",
    d: "M 145.5,210.5 C 147.709,209.024 149.042,209.691 149.5,212.5C 148.167,211.833 146.833,211.167 145.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#5e5e5e",
    d: "M 179.5,210.5 C 178.778,211.551 177.778,212.218 176.5,212.5C 176.5,211.5 176.5,210.5 176.5,209.5C 177.791,209.263 178.791,209.596 179.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#797979",
    d: "M 233.5,210.5 C 235.332,209.282 236.332,209.949 236.5,212.5C 235.222,212.218 234.222,211.551 233.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.651
    },
    fill: "#292929",
    d: "M 262.5,210.5 C 262.833,211.167 263.167,211.833 263.5,212.5C 262.833,212.5 262.167,212.5 261.5,212.5C 258.598,210.885 256.265,211.551 254.5,214.5C 251.5,214.5 248.5,214.5 245.5,214.5C 244.833,213.5 244.167,212.5 243.5,211.5C 249.851,211.443 256.185,211.11 262.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.302
    },
    fill: "#515151",
    d: "M 272.5,204.5 C 272.167,205.167 271.833,205.833 271.5,206.5C 271.063,208.074 270.063,209.241 268.5,210C 266.497,210.335 264.83,211.168 263.5,212.5C 263.167,211.833 262.833,211.167 262.5,210.5C 266.043,208.98 269.376,206.98 272.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6e6e6e",
    d: "M 389.5,210.5 C 390.209,209.596 391.209,209.263 392.5,209.5C 392.5,210.5 392.5,211.5 392.5,212.5C 391.778,211.449 390.778,210.782 389.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#4a4a4a",
    d: "M 425.5,210.5 C 424.533,211.806 423.199,212.473 421.5,212.5C 421.958,209.691 423.291,209.024 425.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6b6b6b",
    d: "M 33.5,210.5 C 34.8333,209.167 36.1667,209.167 37.5,210.5C 38.1667,211.167 38.8333,211.833 39.5,212.5C 37.3146,212.296 35.3146,211.63 33.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#717171",
    d: "M 151.5,212.5 C 152.568,211.566 153.901,211.232 155.5,211.5C 155.393,213.379 155.893,213.712 157,212.5C 157.717,213.044 158.217,213.711 158.5,214.5C 156.071,214.116 153.737,213.449 151.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#818181",
    d: "M 349.5,211.5 C 343.5,212.833 337.5,212.833 331.5,211.5C 337.5,210.167 343.5,210.167 349.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.443
    },
    fill: "#686868",
    d: "M 395.5,212.5 C 395.5,212.167 395.5,211.833 395.5,211.5C 399.044,211.132 402.044,212.132 404.5,214.5C 401.436,214.072 398.436,213.406 395.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#2e2e2e",
    d: "M 486.5,210.5 C 486.389,211.117 486.056,211.617 485.5,212C 479.509,212.499 473.509,212.666 467.5,212.5C 467.5,212.167 467.5,211.833 467.5,211.5C 467.5,211.167 467.5,210.833 467.5,210.5C 474.455,210.703 480.788,210.703 486.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#777777",
    d: "M 261.5,212.5 C 259.167,213.167 256.833,213.833 254.5,214.5C 256.265,211.551 258.598,210.885 261.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#313131",
    d: "M 155.5,211.5 C 159.833,212.833 164.167,212.833 168.5,211.5C 167.694,212.728 166.694,213.728 165.5,214.5C 163.167,214.5 160.833,214.5 158.5,214.5C 158.217,213.711 157.717,213.044 157,212.5C 155.893,213.712 155.393,213.379 155.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6a6a6a",
    d: "M 168.5,211.5 C 170.415,211.216 172.081,211.549 173.5,212.5C 170.975,213.64 168.308,214.307 165.5,214.5C 166.694,213.728 167.694,212.728 168.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6a6a6a",
    d: "M 239.5,212.5 C 240.568,211.566 241.901,211.232 243.5,211.5C 244.167,212.5 244.833,213.5 245.5,214.5C 243.282,214.386 241.282,213.72 239.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#323232",
    d: "M 395.5,211.5 C 401.631,212.211 407.964,212.211 414.5,211.5C 413.694,212.728 412.694,213.728 411.5,214.5C 409.167,214.5 406.833,214.5 404.5,214.5C 402.044,212.132 399.044,211.132 395.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#6a6a6a",
    d: "M 414.5,211.5 C 416.415,211.216 418.081,211.549 419.5,212.5C 416.975,213.64 414.308,214.307 411.5,214.5C 412.694,213.728 413.694,212.728 414.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.282
    },
    fill: "#727272",
    d: "M 134.5,229.5 C 132.817,233.85 129.817,236.85 125.5,238.5C 125.833,237.833 126.167,237.167 126.5,236.5C 128.914,235.089 130.581,233.089 131.5,230.5C 132.609,230.443 133.609,230.11 134.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#646464",
    d: "M 123.5,240.5 C 121.958,241.301 120.292,241.634 118.5,241.5C 118.791,240.351 119.624,239.684 121,239.5C 122.07,239.528 122.903,239.861 123.5,240.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpsilon);
export default __webpack_public_path__ + "static/media/epsilon.fc1af60d5512caaefa93fc4f425750da.svg";
export { ForwardRef as ReactComponent };